import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { hideModal } from 'appSrc/redux/actions';
import { XIcon } from 'appSrc/components/UI';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import CategoryForm from './CategoryForm';
import style from './styles/style.module.css';


class EditCategoryModal extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            fetching: false,
        };
    }
    submit = ( updates ) => {
        this.setState( { fetching: true } );

        if( this.props.modalProps.callback ) {
            this.props.modalProps.callback( {
                name: updates.name,
                status: updates.status,
                heading: updates.heading,
                parent_id: updates.parent_id,
            } )
            .then( () => {
                this.setState( { fetching: false } );
                this.props.closeModal();
            } );
        }
    }
    render() {
        const { modalName, modalProps } = this.props;
        let isOpen = modalProps.modalIsOpen && modalName === 'editCategoryModal';

        const category = modalProps.category || {};

        return (
            <ReactModal
            isOpen={ isOpen }
            contentLabel="Edit Product"
            onRequestClose={ this.props.closeModal }
            className={ style.categoryModal + ' modal-popup' }
            overlayClassName='modal-overlay' >
                <div className='modal-title'>
                    <h2>Edit Category</h2>
                </div>
                <div className='close-button' onClick={ this.props.closeModal }>
                    <XIcon size={ 24 } />
                </div>
                <CategoryForm onSubmit={ this.submit } initialValues={ category } />
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </ReactModal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        modalName: state.modal.modalName,
        modalProps: state.modal.modalProps,
    };
};
const mapDispatchToProps = ( dispatch ) => {
    return {
        closeModal: () => {
            dispatch( hideModal( 'editCategoryModal' ) );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( EditCategoryModal );
